import * as angular from 'angular';
import { Observable } from 'rxjs';
import { combineLatest, filter, map } from 'rxjs/operators';

import { AppStore } from '~/types/main.types';

import { MixableBaseController } from '../../../common/component';
import { NotebookRunState } from '@mode/legacy/types-app-state';
import { NotebookSelectors } from '../../../selectors/notebook.selectors';
import { SelectedReportSelectors } from '../../../selectors/selected-report.selectors';
import { NotebookDataService } from '../../../services/notebook-data-service';

class NotebookViewController extends MixableBaseController {
  static $inject = ['RxStoreService', 'NotebookDataService'];

  notebookToken$: Observable<string>;
  cellTokens$: Observable<string[]>;
  noNotebook$: Observable<boolean>;
  loading$: Observable<boolean>;
  hasError$: Observable<boolean>; // Not currently handled

  constructor(
    private rxStore: AppStore,
    private notebookDataService: NotebookDataService
  ) {
    super();
  }

  $onInit() {
    const notebook$ = this.rxStore.select(NotebookSelectors.notebookResourcesArray).pipe(map((arr) => arr.first()));
    this.notebookToken$ = this.rxStore.select(NotebookSelectors.selectedNotebookToken);
    this.hasError$ = this.rxStore
      .select(NotebookSelectors.vizRunState)
      .pipe(map((state) => state === NotebookRunState.Failed));
    this.loading$ = this.rxStore.select(SelectedReportSelectors.getNotebookLoading);
    this.noNotebook$ = this.rxStore
      .select(SelectedReportSelectors.getHasNotebook)
      .pipe(combineLatest(this.loading$, (hasNotebook, loading) => !hasNotebook && !loading));

    this.cellTokens$ = this.rxStore.select(NotebookSelectors.selectedNotebookCellTokens).pipe(
      filter((tokens) => tokens != null),
      map((tokens) => tokens.toArray())
    );

    this.notebookDataService.loadNotebookInSelectedReport();
  }
}

export const notebookViewComponent: angular.IComponentOptions = {
  controller: NotebookViewController,
  controllerAs: 'ctrl',
  template: `
  <div class="mode-notebook-loading" ng-show="ctrl.loading$ | async:this"><i class="icon-logo-animated"></i>Loading notebook</div>
  <div class="mode-notebook-error" ng-show="ctrl.hasError$ | async:this"><i class="icon-logo-animated"></i>There was a problem loading the notebook</div>
  <div class="mode-notebook-none" ng-show="ctrl.noNotebook$ | async:this">There is no notebook for this report</div>
  <div class="mode-notebook-cell-wrapper" resize-cells>
    <mode-notebook-cell-group cell-token="cellToken" read-only="true" notebook-token="ctrl.notebookToken$ | async:this" ng-repeat="cellToken in (ctrl.cellTokens$ | async:this)"></mode-notebook-cell-group>
  </div>
  `,
};
